import { useEffect } from 'react';
import { useOfflineStore } from '../stores/offlineStore';

export function useOffline() {
  const { setOnline, syncPending, isOnline } = useOfflineStore();

  useEffect(() => {
    function handleOnline() {
      setOnline(true);
      syncPending().catch(console.error);
    }
    function handleOffline() {
      setOnline(false);
    }

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [setOnline, syncPending]);

  return { isOnline };
}
